import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { applyKeyframe, mediaQuery } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

const { spacing } = theme;

export const link = css`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
`;

export const productListWrapper = css`
  margin: 0 0 ${spacing.xl}px 0;
`;

export const productCardGridItem = css`
  grid-column: auto / span 6;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: auto / span 4;
    `,
  )};
`;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fadeIn = css`
  animation: ${applyKeyframe(fadeInAnimation)} 400ms linear;
`;

export const inListingCalloutWrapper = css`
  grid-column: span 12;
  grid-row-start: 8;
`;
